import styled from 'styled-components';
import { mixins } from '@sy/component-library';

const { media } = mixins;

interface LayoutProps {
	overflowVisible?: boolean;
}

export const Layout = styled('div')<LayoutProps>`
	display: flex;
	flex: 1;
	flex-direction: column;
	justify-content: space-between;
	min-height: 100vh;
	overflow-x: ${({ overflowVisible }) =>
		overflowVisible ? 'visible' : 'hidden'};
`;

export const Top = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;

	${media.belowMedium`
		height: auto;
	`};
`;

export const TopPadding = styled.div`
	margin-top: 32px;

	${media.medium`
		margin-top: 50px;
	`}
`;
